import { Component ,EventEmitter,Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resources-navcard',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './resources-navcard.component.html',
  styleUrl: './resources-navcard.component.scss'
})
export class ResourcesNavcardComponent {
@Output() close = new EventEmitter<void>();

constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

    navigateTo(path: string) {
    this.close.emit(); 
    this.router.navigate([`/${path}`]);
  }
}
